import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ShareService } from '@core/services/share-data/share-data.service';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { ActivatedRoute } from '@angular/router';
import { STORAGE_NAMES, SELECTORS, CLASSES } from '@root/app.config';

declare const $: any;
import * as _ from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-overview-page',
	templateUrl: './overview-page.component.html',
	styleUrls: ['./overview-page.component.scss', './overview-page.responsive.scss'],
})
export class OverviewPageComponent implements OnInit, AfterViewInit {
	@ViewChild('retailerInfo') retailerInfo: ElementRef;
	@ViewChild('overviewPage') overviewPage: ElementRef;

	addInfoAvailability = false;

	constructor(
		private shareService: ShareService,
		private sessionStorageService: SessionStorageService,
		private route: ActivatedRoute,
		private changeDetection: ChangeDetectorRef,
		private destroyRef: DestroyRef,
	) {}

	ngOnInit(): void {
		this.shareService.getRetailerInfo.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
			if (this.addInfoAvailability) {
				$(SELECTORS.request_button).removeClass(CLASSES.loading);
				this.scrollToRetailerInfo();
			}

			const embeddedRetailer = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_embedded_retailer);
			this.addInfoAvailability = res;

			if (this.addInfoAvailability && !embeddedRetailer) {
				this.scrollToRetailerInfo();
			}

			this.changeDetection.markForCheck();
		});

		this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			this.setSessionStorage();

			this.changeDetection.markForCheck();
		});

		this.setLoadingHandler();
	}

	scrollToRetailerInfo() {
		setTimeout(() => {
			this.retailerInfo.nativeElement.scrollIntoView({
				behavior: 'smooth',
			});
		}, 200);
	}

	ngAfterViewInit() {
		this.shareService.getLoadingSpinner.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
			setTimeout(() => {
				$(this.overviewPage.nativeElement).find(SELECTORS.overview_section).toggleClass(CLASSES.loading, res);
			});

			this.changeDetection.markForCheck();
		});
	}

	setSessionStorage(): void {
		const sessionStorageSession = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_blind_session);

		if (sessionStorageSession) {
			this.shareService.setLinkSessionKey(sessionStorageSession);
		}
	}

	setLoadingHandler(): void {
		const savedStatus = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_blind_session_saved);
		const savedData = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_blind_data);

		if (savedStatus && _.isEmpty(savedData)) {
			setTimeout(() => {
				$(this.overviewPage.nativeElement).find(SELECTORS.overview_section).addClass(CLASSES.loading);
			});
		}
	}

	setInfoAvailability(status: boolean): void {
		this.addInfoAvailability = status;
	}
}
